<script lang="ts">
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {getUserOldTransactions} from 'src/components/cabinet/#services/getUserOldTransactions'
    import Time from 'svelte-time'

    export let userId

    let currentPage = 0
    let perPage = 15
    let maxButtons = 5
    let totalCount = 5

    let currencyList = {
        1: 'Points',
        2: 'SOUL',
        3: 'Membership',
        4: 'ETH',
        5: 'LIS'
    }

    let descriptionList = {
        '1': 'Task complete',
        '2': 'Email confirm',
        '3': 'Referral system',
        '4': 'Referral system',
        '5': 'Not completed task',
        '6': 'Not completed task',
        '7': 'Task complete',
        '8_1_2': 'App exchange',
        '9_2': 'Withdrawal',
        '10_1': 'Withdrawal canceled',
        '10_2': 'Withdrawal canceled',
        '11': 'Administrator action',
        '12': 'Not completed task',
        '13': 'From game',
        '14': 'Referral system',
        '15': 'Task complete',
        '16': 'Deposit',
        'lottery': 'Lottery',
        'confirm_email': 'Email confirm',
        'soul_withdrawal': 'Withdrawal',
        'cancel_by_admin': 'Withdrawal canceled',
        'withdrawal_cenceled': 'Withdrawal canceled',
        'cancel_time': 'Withdrawal canceled',
        'admin_action': 'Administrator action',
        'app_add_balance': 'Deposit in game',
        'app_withdraw_balance': 'Withdraw from game',
        'from_game': 'Earn in game',
        'exchange_game_currency': 'Earn in game',
        'completed_task': 'Task complete',
        'app_exchange': 'Swap to SOUL',
        'from_lottery': 'Lottery win',
        'deposit': 'Deposit',
        'open_saving': 'Staking',
        'close_saving': 'Staking',
        'completed_saving': 'Staking',
        'soul_by_eth': 'Buy SOUL',
        'soul_in_game': 'Deposit to Lucky Soul',
        'soul_from_game': 'Withdrawal from Lucky Soul',
        'soul_by_money': 'Buy SOUL by USD',
        'membership_by_money': 'Membership bonus',
        'unlink_account': 'Unlink account',
        'reset_device': 'Unlink account',
        'reset_wallet': 'Waller reset',
        'apply_membership': 'Apply membership',
        'user_get_membership': 'Apply membership',
        'deposit_in_game': 'Deposit to game',
        'buy_membership': 'Buy membership',
        'buy_membership_eth': 'Buy membership by ETH',
        'referral_system': 'Referral system',
        'not_completed_task': 'Not completed task',
        'change_nickname': 'Changed nickname',
        'staking_start': 'Staking',
        'staking_end': 'Staking',
        'staking_reward': 'Staking',
        'bank_deposit_user_close': 'Staking',
        'bank_deposit_system_close': 'Staking',
        'bank_deposit_open': 'Staking',
        'token_sale_reward': 'Every week reward',
        'cancel_by_user': 'Withdrawal canceled',
        'wallet_deposit': 'Deposit',
        'exchanged_by_user': 'Swap',
        'token_swap': 'Swap',
        'purchase_soul': 'Buy SOUL',
        'interkassa_purchase_soul': 'Buy SOUL',
        'buy_user_statuses': 'Buy membership',
        'membership_buying': 'Buy membership',
        'membership_buying_eth': 'Buy membership (ETH)',
        'user_reset_wallet': 'Wallet reset',
        'transfer_to_game': 'Transfer to game',
        'convert_free_tickets': 'Convert free tickets',
        'wallet_exchange': 'Wallet exchange',
    }

    function getDescription(key) {
        return descriptionList[key] ? descriptionList[key] : key
    }

    $: getUserOldTransactions.send({
        data: {
            userId,
            page: currentPage + 1,
            perPage,
        },
    })
</script>

<div class="transactions-list">
    <Table bordered striped responsive>
        <thead>
        <tr>
            <td class="text-center">Amount</td>
            <td class="text-center">Description</td>
            <td class="text-center">Date</td>
        </tr>
        </thead>
        <tbody>
        {#if $getUserOldTransactions.loading}
            {#each {length:perPage} as item}
                <tr>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                </tr>
            {/each}
        {:else if $getUserOldTransactions.error || !$getUserOldTransactions.hasValue }
            <tr>
                <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
            </tr>
        {:else}
            {#each $getUserOldTransactions.value.data as { date, amount, currency, description }}
                <tr>
                    <td class="nobr notranslate">
                        {#if amount > 0}
                            <span class="text-success">+{Math.round((+amount + Number.EPSILON) * 10000) / 10000} {currencyList[+currency]}</span>
                        {:else if amount < 0}
                            <span class="text-danger">{Math.round((+amount + Number.EPSILON) * 10000) / 10000} {currencyList[+currency]}</span>
                        {:else}
                            <span>{currencyList[+currency]}</span>
                        {/if}
                    </td>
                    <td>{getDescription(description)}</td>
                    <td class="text-center"><Time relative timestamp={date}/></td>
                </tr>
            {:else}
                <tr>
                    <td class="text-center" colspan="3">No items</td>
                </tr>
            {/each}
        {/if}
        </tbody>
    </Table>
    {#if $getUserOldTransactions.hasValue}
        <Pagination
            bind:currentPage={currentPage}
            totalCount={$getUserOldTransactions.value.totalCount}
            {perPage}
            {maxButtons}
            disabled={$getUserOldTransactions.loading || $getUserOldTransactions.loading}
        />
    {/if}
</div>

<style>
    .transactions-list :global(table) {
        width: auto;
    }

    .transactions-list :global(td) {
        vertical-align: middle;
        padding: 12px 25px;
        line-height: normal;
    }

    .transactions-list :global(nav .pagination) {
        justify-content: flex-start;
    }
</style>
